import { serves as auth } from "@/modulos/auth";
import { serves as home } from "@/modulos/home";
import { serves as trabalhador } from "@/modulos/trabalhador";
import { serves as depedentes } from "@/modulos/depedentes";
import { serves as tomador } from "@/modulos/tomador";
import { serves as taxa } from "@/modulos/taxa";
import { serves as tabelapreco } from "@/modulos/tabelapreco";
import { serves as tabelaprecorublica } from "@/modulos/tabelaprecorublica";
import { serves as comissionado } from "@/modulos/comissionador";
import { serves as boletinstabela } from "@/modulos/boletins/tabela";
import { serves as boletinscartaoponto } from "@/modulos/boletins/cartaoponto";
import { serves as boletinstabelatrabalhadores } from "@/modulos/boletins/tabela/trabalhadores";
import { serves as boletinscartaopontotrabalhadores } from "@/modulos/boletins/cartaoponto/trabalhadores";
import { serves as inss } from "@/modulos/inss";
import { serves as irrf } from "@/modulos/irrf";
import { serves as vale } from "@/modulos/vale";
import { serves as folhar } from "@/modulos/folhar";
import { serves as fatura } from "@/modulos/fatura";
import { serves as rescisaocontrator } from "@/modulos/rescisaocontrator";
import { serves as backup } from "@/modulos/backup";
import { serves as acidentetrabalhor } from "@/modulos/trabalhador/sst/acidentetrabalhor";
import { serves as saudetrabalhor } from "@/modulos/trabalhador/sst/saudetrabalhador";
import { serves as ambientetrabalhor } from "@/modulos/trabalhador/sst/ambientetrabalhor";
import { serves as avuso } from "@/modulos/avuso";
import { serves as cartademissao } from "@/modulos/cartademissao";
import { serves as dstavulso } from "@/modulos/dstavulso";
import { serves as ferias } from "@/modulos/ferias";
import { serves as decimo } from "@/modulos/decimo";
import { serves as rubrica } from "@/modulos/rubrica";
import { serves as aplicativo } from "@/modulos/app";
import { serves as folharaplicativo } from "@/modulos/folhar/page/aplicativo";
import { serves as categoria } from "@/modulos/categoria";
import { serves as cbo } from "@/modulos/cbo";
import { serves as cargohoraria } from "@/modulos/cargohoraria";
import { serves as trabalhadorlotacao } from "@/modulos/trabalhador/lotacao";
import { serves as trabalhadorafastamento } from "@/modulos/trabalhador/afastamento";
import { serves as trabalhadorcontrato } from "@/modulos/trabalhador/contrato";
import { serves as trabalhadordesligamento } from "@/modulos/trabalhador/desligamento";
import { serves as trabalhadorcessao } from "@/modulos/trabalhador/cessao";
import { serves as trabalhadorreintegracao } from "@/modulos/trabalhador/reintegracao";
import { serves as tabelaprecorublicaevento } from "@/modulos/tabelaprecorublica/esocial";
import { serves as folharevento } from "@/modulos/folhar/page/esocial";
import { serves as folharevento1270 } from "@/modulos/folhar/page/esocial/evento1270";
import { serves as desligamentotabelapreco } from "@/modulos/trabalhador/desligamento/tabelapreco";
import { serves as trabalhadorvaletransporte } from "@/modulos/trabalhador/valetransporte";
import { serves as trabalhadorvalealimentacao } from "@/modulos/trabalhador/valealimentacao";
import { serves as folharverpagamento } from "@/modulos/folhar/page/verpagamento";
import { serves as folharverpagamentotomador } from "@/modulos/folhar/page/verpagamento/tomador";
import { serves as folhartaxas } from "@/modulos/configuracao/folha/taxas";
import { serves as folharauto } from "@/modulos/configuracao/folha/auto";
import { serves as calendariodiasuteis } from "@/modulos/configuracao/ferias/calendariodiasuteis";
import { serves as feriado } from "@/modulos/configuracao/ferias/feriado";
import { serves as trabalhadorauto } from "@/modulos/trabalhador/configuracao/geral";
import { serves as certificado } from "@/modulos/certificado";
import { serves as configuracaotrabalhador2200 } from "@/modulos/configuracao/esocial/trabalhador/evento2200";
import { serves as empresa } from "@/modulos/empresa";
import { serves as trabalhadorbackup } from "@/modulos/configuracao/backup/trabalhador";
import { serves as epi } from "@/modulos/trabalhador/epi";
import { serves as tomadorbackup } from "@/modulos/configuracao/backup/tomador";
import { serves as tabelaprecobackup } from "@/modulos/configuracao/backup/tabelapreco";
import { serves as boletimbackup } from "@/modulos/configuracao/backup/boletim";
import { serves as trabalhadoradvertencia } from "@/modulos/trabalhador/advertencia";
import { serves as trabalhadornotas } from "@/modulos/trabalhador/notas";
import {serves as usuario} from '@/modulos/usuarios';
import {serves as aviso} from '@/modulos/componente/dashboard';
import {serves as alerta} from '@/modulos/aviso';
export default{
    auth,
    home,
    trabalhador,
    depedentes, 
    tomador,
    taxa,
    tabelapreco,
    tabelaprecorublica,
    comissionado,
    boletinstabela,
    boletinstabelatrabalhadores,
    inss,
    irrf,
    vale,
    folhar,
    fatura,
    boletinscartaoponto,
    boletinscartaopontotrabalhadores,
    rescisaocontrator,
    backup,
    acidentetrabalhor,
    avuso,
    cartademissao,
    dstavulso,
    ferias,
    decimo,
    rubrica,
    aplicativo,
    folharaplicativo,
    categoria,
    cbo,
    cargohoraria,
    trabalhadorlotacao,
    trabalhadorafastamento,
    trabalhadorcontrato,
    trabalhadordesligamento,
    trabalhadorcessao,
    trabalhadorreintegracao,
    tabelaprecorublicaevento,
    folharevento,
    desligamentotabelapreco,
    trabalhadorvaletransporte,
    trabalhadorvalealimentacao,
    folharverpagamento,
    folhartaxas,
    folharauto,
    calendariodiasuteis,
    feriado,
    trabalhadorauto,
    certificado,
    configuracaotrabalhador2200,
    empresa,
    trabalhadorbackup,
    epi,
    saudetrabalhor,
    ambientetrabalhor,
    tomadorbackup,
    tabelaprecobackup,
    boletimbackup,
    folharverpagamentotomador,
    folharevento1270,
    trabalhadoradvertencia,
    trabalhadornotas,
    usuario,
    aviso,
    alerta
}